<template>
  <div style="margin-left:10px;">
    <div id="progressCircle" v-bind:class="{ complete: percent >= .98 }" v-on:click="goBack">
      <svg :height="width" :width="height">
        <circle :cx="(width / 2)" :cy="(height / 2)" :r="(width / 2 - 2)" />
        <circle
          id="progress"
          class="progress"
          :style="{strokeDasharray: strokeDasharray, strokeDashoffset: strokeDashoffset}"
          :cx="(width / 2)"
          :cy="(height / 2)"
          :r="(width / 2 - 2)"
        />
        <line
          :x1="(width * margin)"
          :y1="(width * margin)"
          :x2="(width - (width * margin))"
          :y2="(height - (height * margin))"
        />
        <line
          :x1="(width - (width * margin))"
          :y1="(height * margin)"
          :x2="(width * margin)"
          :y2="(height - (width * margin))"
        />
      </svg>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  computed: mapState(["offsetTop"]),
  data() {
    return {
      message: "Scroll 2000px",
      height: 48,
      width: 48,
      margin: 0.3,
      total: 0,
      progress: null,
      strokeDasharray: 100,
      strokeDashoffset: 100,
      percent: 0,
      read: false,
    };
  },
  mounted() {
    this.total = Math.round(this.width * Math.PI);
    this.strokeDasharray = this.strokeDashoffset = this.total;
    this.progress = document.getElementById("progress");
    // window.addEventListener("scroll", this.handleScroll, true);
  },
  destroyed() {
    // window.removeEventListener("scroll", this.handleScroll, true);
  },
  watch: {
    offsetTop() {
      this.scroll = window.scrollY;
      if (!this.ticking) {
        window.requestAnimationFrame(
          function () {
            // document.body.scrollHeight
            this.percent = (
              this.scroll /
              (document.getElementById("more_articles").offsetTop -
                window.innerHeight)
            ).toFixed(2);
            if (this.percent >= 1) {
              if (!this.read) {
                this.read = true;
                this.$store.dispatch("readArticle");
              }
              this.percent = 1;
            }
            this.strokeDasharray = this.total + "px";
            this.strokeDashoffset =
              this.total - this.total * this.percent + "px";
            this.ticking = false;
          }.bind(this)
        );
        this.ticking = true;
      }
    },
  },
  methods: {
    goBack() {
      if (this.$store.state.history.length > 1) {
        let goTo = -1;
        for (let i = this.$store.state.history.length - 1; i > 0; i--) {
          if (window.location.pathname !== this.$store.state.history[i].path) {
            this.$router.go(goTo);
            break;
          }
          goTo--;
        }
      } else {
        this.$router.push({ path: "/feeds" });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
</style>